/**
 * Utilidad para migrar tokens JWT existentes a Sanctum
 * Este script se ejecuta al cargar la aplicación para limpiar tokens JWT antiguos
 */

export const migrateTokensToSanctum = () => {
  console.log('🔄 Verificando migración de tokens JWT a Sanctum...');
  
  // Claves antiguas de JWT
  const OLD_JWT_KEYS = [
    'planillas_jwt_token',
    'jwt_token',
    'token',
    'auth_token'
  ];
  
  // Nueva clave de Sanctum
  const SANCTUM_TOKEN_KEY = 'planillas_sanctum_token';
  
  let foundOldTokens = false;
  
  // Verificar si hay tokens JWT antiguos
  OLD_JWT_KEYS.forEach(oldKey => {
    const oldToken = localStorage.getItem(oldKey);
    if (oldToken && oldKey !== SANCTUM_TOKEN_KEY) {
      console.log(`🗑️ Encontrado token JWT antiguo: ${oldKey}`);
      localStorage.removeItem(oldKey);
      foundOldTokens = true;
    }
  });
  
  if (foundOldTokens) {
    console.log('🧹 Tokens JWT antiguos eliminados');
    console.log('ℹ️ Los usuarios necesitarán hacer login nuevamente');
    
    // También limpiar datos de usuario antiguos para forzar re-login
    localStorage.removeItem('planillas_user');
    localStorage.removeItem('planillas_user_roles');
    localStorage.removeItem('planillas_user_permissions');
    localStorage.removeItem('planillas_company');
    
    return true; // Indica que se encontraron tokens antiguos
  }
  
  console.log('✅ No se encontraron tokens JWT antiguos');
  return false;
};

/**
 * Verificar si el token actual es válido para Sanctum
 */
export const validateSanctumToken = (token) => {
  if (!token) return false;
  
  // Los tokens de Sanctum son más largos y tienen un formato específico
  // Formato típico: número|hash_largo
  const sanctumPattern = /^\d+\|[a-zA-Z0-9]{40,}$/;
  
  if (sanctumPattern.test(token)) {
    console.log('✅ Token válido para Sanctum');
    return true;
  }
  
  console.log('⚠️ Token no es compatible con Sanctum, se requiere re-login');
  return false;
};

/**
 * Limpiar todos los datos de autenticación
 */
export const clearAllAuthData = () => {
  console.log('🧹 Limpiando todos los datos de autenticación...');
  
  const keysToClean = [
    'planillas_sanctum_token',
    'planillas_jwt_token',
    'planillas_user',
    'planillas_user_roles',
    'planillas_user_permissions',
    'planillas_company',
    'jwt_token',
    'token',
    'auth_token'
  ];
  
  keysToClean.forEach(key => {
    localStorage.removeItem(key);
  });
  
  console.log('✅ Datos de autenticación limpiados');
};

export default {
  migrateTokensToSanctum,
  validateSanctumToken,
  clearAllAuthData
};

